import { Link } from 'react-router-dom';
import LegalPageShell from '../components/LegalPageShell';

const metaDescription =
  'Sitemap for Dragon Metalworks: quick links to main sections of our steel fabrication website and legal pages.';

const mainLinks = [
  { to: '/', label: 'Home', hint: 'Hero and overview' },
  { to: '/#about', label: 'About', hint: 'Company and capabilities' },
  { to: '/#services', label: 'Services', hint: 'Fabrication, supply, and structural work' },
  { to: '/#projects', label: 'Projects', hint: 'Selected work' },
  { to: '/#process', label: 'Process', hint: 'How we deliver' },
  { to: '/#whyus', label: 'Why us', hint: 'Reasons to choose us' },
  { to: '/#showcase', label: 'Gallery', hint: 'Workshop and site imagery' },
  { to: '/#contact', label: 'Contact', hint: 'Quote request and details' },
];

const legalLinks = [
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/terms-and-conditions', label: 'Terms & Conditions' },
  { to: '/sitemap', label: 'Sitemap' },
];

export default function SitemapPage() {
  return (
    <LegalPageShell title="Sitemap" description={metaDescription}>
      <header className="legal-page-header">
        <p className="legal-page-kicker">Navigate</p>
        <h1>Sitemap</h1>
        <p className="legal-page-lead">
          Jump to a main section of our site or open a legal page. In-page links open the homepage and scroll to the
          relevant section.
        </p>
      </header>

      <section className="legal-section" aria-labelledby="sitemap-main">
        <h2 id="sitemap-main">Main pages &amp; sections</h2>
        <ul className="sitemap-list">
          {mainLinks.map((item) => (
            <li key={item.to}>
              <Link to={item.to} className="sitemap-link">
                <span className="sitemap-link-label">{item.label}</span>
                <span className="sitemap-link-hint">{item.hint}</span>
              </Link>
            </li>
          ))}
        </ul>
      </section>

      <section className="legal-section" aria-labelledby="sitemap-legal">
        <h2 id="sitemap-legal">Legal</h2>
        <ul className="sitemap-list sitemap-list--compact">
          {legalLinks.map((item) => (
            <li key={item.to}>
              <Link to={item.to} className="sitemap-link">
                <span className="sitemap-link-label">{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </LegalPageShell>
  );
}
